(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flux-client-services"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.flux-client-services__form form').forEach((form) => {
    const topic = form.querySelector('[data-flux-topic]');
    const conditionalFields = form.querySelectorAll('[data-conditional-field]');

    if (!topic || conditionalFields.length === 0) return;

    const updateConditionalFields = () => {
      const selectedOption = topic.options[topic.selectedIndex];
      const fieldsToShow = selectedOption ? selectedOption.dataset.show.split(' ') : [];

      conditionalFields.forEach((field) => {
        field.hidden = !fieldsToShow.includes(field.dataset.conditionalField);
      });
    };

    topic.addEventListener('change', updateConditionalFields);
    updateConditionalFields();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-header"]) return;
  try {
    
  (() => {
    const initializeMobileMenu = (menu) => {
    if (menu.dataset.fluxMobileMenuInitialized === 'true') return;

    const toggle = menu.querySelector(':scope > summary');
    const panel = menu.querySelector('.flux-mobile-menu__panel');

    if (!toggle || !panel) return;

    menu.dataset.fluxMobileMenuInitialized = 'true';

    const mobileViewport = window.matchMedia('(max-width: 989px)');
    const supportsInert = 'inert' in HTMLElement.prototype;
    const openMenuLabel = toggle.dataset.openLabel || toggle.getAttribute('aria-label');
    const closeMenuLabel = toggle.dataset.closeLabel || openMenuLabel;
    const inertedElements = new Map();
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'summary',
      '[tabindex]:not([tabindex^="-"])',
    ].join(',');
    const ignoredInertTags = new Set(['LINK', 'META', 'SCRIPT', 'STYLE', 'TEMPLATE']);
    let isActive = false;
    let returnFocus = null;
    let inertObserver = null;

    const getFocusableElements = () =>
      [...menu.querySelectorAll(focusableSelector)].filter(
        (element) =>
          element instanceof HTMLElement &&
          element.tabIndex >= 0 &&
          !element.closest('[inert]') &&
          element.getClientRects().length > 0,
      );

    const makeOutsideContentInert = () => {
      if (!menu.isConnected) {
        closeMenu({ restoreFocus: false });
        return;
      }

      let currentBranch = menu;

      while (currentBranch && currentBranch !== document.body) {
        const parent = currentBranch.parentElement;
        if (!parent) break;

        [...parent.children].forEach((sibling) => {
          if (
            sibling === currentBranch ||
            sibling.contains(menu) ||
            !(sibling instanceof HTMLElement) ||
            ignoredInertTags.has(sibling.tagName) ||
            inertedElements.has(sibling)
          ) {
            return;
          }

          inertedElements.set(sibling, {
            hadInert: sibling.hasAttribute('inert'),
            ariaHidden: sibling.getAttribute('aria-hidden'),
            hadMarker: sibling.hasAttribute('data-flux-menu-inert'),
          });
          sibling.setAttribute('inert', '');
          sibling.setAttribute('data-flux-menu-inert', '');

          if (!supportsInert) {
            sibling.setAttribute('aria-hidden', 'true');
          }
        });

        currentBranch = parent;
      }
    };

    const restoreOutsideContent = () => {
      inertedElements.forEach((state, element) => {
        if (!element.isConnected) return;

        if (state.hadInert) {
          element.setAttribute('inert', '');
        } else {
          element.removeAttribute('inert');
        }

        if (!supportsInert) {
          if (state.ariaHidden === null) {
            element.removeAttribute('aria-hidden');
          } else {
            element.setAttribute('aria-hidden', state.ariaHidden);
          }
        }

        if (!state.hadMarker) {
          element.removeAttribute('data-flux-menu-inert');
        }
      });
      inertedElements.clear();
    };

    const focusInsideMenu = (preferLast = false) => {
      const focusableElements = getFocusableElements();
      const target = preferLast
        ? focusableElements[focusableElements.length - 1]
        : panel.querySelector('a[href]') || focusableElements[0] || panel;

      target?.focus({ preventScroll: true });
    };

    const handleDocumentKeydown = (event) => {
      if (!isActive || !menu.open) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeMenu({ restoreFocus: true });
        return;
      }

      if (event.key !== 'Tab') return;

      const focusableElements = getFocusableElements();
      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];

      if (!first || !last) {
        event.preventDefault();
        panel.focus({ preventScroll: true });
        return;
      }

      if (!menu.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const handleDocumentFocus = (event) => {
      if (isActive && menu.open && !menu.contains(event.target)) {
        focusInsideMenu();
      }
    };

    const activateMenu = () => {
      if (isActive || !mobileViewport.matches) return;

      isActive = true;
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : toggle;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', closeMenuLabel);
      document.documentElement.classList.add('flux-navigation-open');
      makeOutsideContentInert();

      inertObserver = new MutationObserver(makeOutsideContentInert);
      inertObserver.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('keydown', handleDocumentKeydown, true);
      document.addEventListener('focusin', handleDocumentFocus, true);

      requestAnimationFrame(() => {
        if (isActive && menu.open) focusInsideMenu();
      });
    };

    const deactivateMenu = ({ restoreFocus = true } = {}) => {
      const shouldRestoreFocus = isActive && restoreFocus;
      isActive = false;
      inertObserver?.disconnect();
      inertObserver = null;
      document.removeEventListener('keydown', handleDocumentKeydown, true);
      document.removeEventListener('focusin', handleDocumentFocus, true);
      document.documentElement.classList.remove('flux-navigation-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', openMenuLabel);
      restoreOutsideContent();

      if (shouldRestoreFocus) {
        const target =
          returnFocus?.isConnected && returnFocus !== document.body && !returnFocus.closest('[inert]')
            ? returnFocus
            : toggle;
        target.focus({ preventScroll: true });
      }

      returnFocus = null;
    };

    const closeMenu = ({ restoreFocus = true } = {}) => {
      menu.removeAttribute('open');
      deactivateMenu({ restoreFocus });
    };

    const handleToggle = () => {
      if (menu.open && mobileViewport.matches) {
        activateMenu();
      } else {
        if (menu.open) menu.removeAttribute('open');
        deactivateMenu();
      }
    };

    const handlePanelClick = (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (link && panel.contains(link)) closeMenu({ restoreFocus: false });
    };

    const handleViewportChange = (event) => {
      if (!event.matches && (menu.open || isActive)) {
        const focusWasInsideMenu = menu.contains(document.activeElement);
        const desktopFocusTarget = menu.closest('.flux-header')?.querySelector('.flux-header__brand');
        closeMenu({ restoreFocus: false });

        if (focusWasInsideMenu && desktopFocusTarget instanceof HTMLElement) {
          desktopFocusTarget.focus({ preventScroll: true });
        }
      }
    };

    const handlePageHide = () => closeMenu({ restoreFocus: false });
    const sectionContainer = menu.closest('.shopify-section');
    const handleSectionUnload = (event) => {
      if (!(event.target instanceof Element) || !sectionContainer || !event.target.contains(menu)) return;

      closeMenu({ restoreFocus: false });
      menu.removeEventListener('toggle', handleToggle);
      panel.removeEventListener('click', handlePanelClick);
      window.removeEventListener('pagehide', handlePageHide);
      document.removeEventListener('shopify:section:unload', handleSectionUnload);

      if (typeof mobileViewport.removeEventListener === 'function') {
        mobileViewport.removeEventListener('change', handleViewportChange);
      } else {
        mobileViewport.removeListener(handleViewportChange);
      }

      delete menu.dataset.fluxMobileMenuInitialized;
    };

    menu.addEventListener('toggle', handleToggle);
    panel.addEventListener('click', handlePanelClick);
    window.addEventListener('pagehide', handlePageHide);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    if (typeof mobileViewport.addEventListener === 'function') {
      mobileViewport.addEventListener('change', handleViewportChange);
    } else {
      mobileViewport.addListener(handleViewportChange);
    }

    toggle.setAttribute('aria-expanded', String(menu.open && mobileViewport.matches));
    toggle.setAttribute('aria-label', menu.open && mobileViewport.matches ? closeMenuLabel : openMenuLabel);
    if (menu.open) handleToggle();
    };

    const initializeMobileMenus = (root = document) => {
      if (!root || typeof root.querySelectorAll !== 'function') return;

      if (root instanceof Element && root.matches('.flux-mobile-menu')) {
        initializeMobileMenu(root);
      }
      root.querySelectorAll('.flux-mobile-menu').forEach(initializeMobileMenu);
    };

    initializeMobileMenus();

    if (!window.__fluxMobileMenuSectionLoadHandler) {
      window.__fluxMobileMenuSectionLoadHandler = (event) => initializeMobileMenus(event.target);
      document.addEventListener('shopify:section:load', window.__fluxMobileMenuSectionLoadHandler);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
